<template>
    <modal name="update_role" height="auto" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="$t('Update role')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="update(validate)">
                    <app-input id="name" v-model="form.name" name="name" rules="required">
                        <template #label>
                            {{ $t('Name') }}*
                        </template>
                    </app-input>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Update') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import RoleService from '@services/role.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            form: {},
            loading: false,
            role_id: null
        };
    },
    methods: {
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    RoleService.update(this.role_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.hide();
                        this.$emit('setRole', res);
                    });
                }
            });
        },
        beforeOpen(event) {
            const role = event.params.role;
            if (role) {
                this.form.name = role.name;
                this.role_id = role.id;
            }
        },
        hide() {
            this.$modal.hide('update_role');
        }
    }
};
</script>
